import { render, staticRenderFns } from "./VEstimatesPlaceholder.vue?vue&type=template&id=8a253854&"
import script from "./VEstimatesPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./VEstimatesPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./VEstimatesPlaceholder.vue?vue&type=style&index=0&id=8a253854&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports